const ComboBoostDescription = ({ boostDescriptionText }) => {
	return (
		<div className="vs--bet-slip-combo-boost-description vs--title-white vs--font-regular vs--font-small">
			{boostDescriptionText}
		</div>
	)
}
export default ComboBoostDescription 